import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

/**
 * @typedef {Object} Props
 * @property {boolean} open
 * @property {string} userId
 * @property {(userid: string, reason: string) => void} onSubmit
 * @property {() => void} onCancel
 */

 /**
  * @typedef {Object} State
  * @property {string} disabledMessage
  */

/**
 * @extends React.Component<Props, State>
 */
export default class UserDisableModal extends React.Component {
  /** @type {State} */
  state = {
    disabledMessage: '',
  };

  handleOk = (e) => {
    const { disabledMessage } = this.state;
    const { userId, onSubmit } = this.props;
    onSubmit(userId, disabledMessage);
  };

  handleCancel = (e) => {
    const { onCancel } = this.props;
    onCancel();
  };

  onMessageChange = e => this.setState({ disabledMessage: e.target.value });

  render() {
    const { open } = this.props;
    const { disabledMessage } = this.state;

    return (
      <Dialog
        maxWidth="md"
        fullWidth
        aria-labelledby="confirmation-dialog-title"
        open={open}
        onClose={this.handleCancel}
      >
        <DialogTitle id="confirmation-dialog-title">Disable User</DialogTitle>
        <DialogContent>
          <form noValidate autoComplete="off">
            <TextField
              autoFocus
              id="filled-textarea"
              placeholder="Enter reason"
              multiline
              fullWidth
              margin="dense"
              value={disabledMessage}
              onChange={this.onMessageChange}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} variant="contained" color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}